let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a5wLx")).then(() => parcelRequire('ebk7x'));